(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "axios"], factory);
	else if(typeof exports === 'object')
		exports["host-management"] = factory(require("_"), require("axios"));
	else
		root["host-management"] = factory(root["_"], root["axios"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE_cebe__) {
return 